import { ModifyClassDTO, Personalisation } from "stores/classroomStore_I";
import * as classroomApi from "./classroomApi";

export interface CombineClassRequest {
	teacherId: string;
	displayName: string;
	combinedClasses: Class[];
}

export interface CombinedClassResponse {
	id: string;
	stableIdV1: string;
	sourceId: string;
	sourceType: string;
	memberCount: number;
	type: string;
	personalisation: Personalisation;
}

export interface ClassCombinationResponse {
	id: string;
	stableId: string;
	sourceName: string;
	displayName?: string;
	sourceType: string;
	classType: string;
}

export interface Class {
	id: string;
	type: string;
}

export const CreateCombineClass = async (teacherStableIdV1: string, payload: CombineClassRequest): Promise<CombinedClassResponse> => {
	const endpoint = `v1/teachers/${teacherStableIdV1}/combine-classes`;
	return await classroomApi.Post2(endpoint, payload);
};

export const GetClassCombinations = async (classStableId: string, teacherStableId: string): Promise<ClassCombinationResponse[]> => {
	const endpoint = `v1/teachers/${teacherStableId}/class-combinations/${classStableId}`;
	return await classroomApi.Get2(endpoint);
};

export const UpdateClassroomDetails = async (updatedClassroom: ModifyClassDTO): Promise<void> => {
	const endpoint = `classrooms/${updatedClassroom.groupId}`;
	return await classroomApi.Post(endpoint, updatedClassroom);
};
